import type { SwitchFieldProps } from "./FormFields.interface";

export default function SwitchField({
  label,
  value,
  onChange,
}: SwitchFieldProps) {
  return (
    <div className="form-field">
      <label>{label}</label>
      <div
        className={`switch-track ${value ? "switch-track--on" : ""}`}
        onClick={() => onChange(!value)}
      >
        <div className="switch-thumb" />
      </div>
    </div>
  );
}
